import React from 'react';
import styled from 'styled-components';
import {FormattedMessage} from 'react-intl';
import messages from './messages';
import {DisplaySmallest} from 'components/primitives/display';
import {Div} from 'components/primitives/body';


class InvalidToken extends React.Component {

    render() {
        return (
            <Div>
                <DisplaySmallest>
                    <FormattedMessage {...messages.title}/>
                </DisplaySmallest>

                <TextWrapper>
                    <p><FormattedMessage {...messages.description}/></p>
                </TextWrapper>
            </Div>
        );
    }
}

const TextWrapper = styled.div`
  margin: 20px 0;
`;

export default InvalidToken;
